import * as trace from 'owa-trace';
import saveDayViewState from 'mini-calendar-dayview-store/lib/mutators/saveDayViewItems';
import { addDays, getDateString, OwaDate, startOfDay } from 'owa-datetime';
import { CalendarEvent } from 'mini-calendar-event-types';
import { DayViewItemsResponse, groupEventsByAllDayProperty } from 'mini-calendar-day-surface';
import { getCalendarEventsForDays } from 'mini-calendar-events-store';
import { onDayViewLoadingStatusChanged } from '../../actions/publicActions';
import { createAppContext } from 'mini-app-context';
import datapoints from '../../datapoints';

const DAYS_TO_LOAD_OFFSETS: number[] = [-1, 0, 1];

let lastActiveRequestToken = null;

/**
 * Function to load day view items (right now it loads for three days to support swipe coming in future)
 * @param dayToLoad
 */
export default async function loadDayViewItems(dayToLoad: OwaDate, requestToken?: number) {
    try {
        const dayViewContext = createAppContext();

        // Show spinner until we get the new day view items
        onDayViewLoadingStatusChanged(true);

        lastActiveRequestToken = requestToken;
        const daysToFetchData: OwaDate[] = DAYS_TO_LOAD_OFFSETS.map((offset: number) =>
            startOfDay(addDays(dayToLoad, offset))
        );
        const calendarItems: CalendarEvent[][] = await getCalendarEventsForDays(daysToFetchData);
        const dayViewItems: DayViewItemsResponse[] = calendarItems.map(groupEventsByAllDayProperty);

        dayViewContext.signal(datapoints.loadDayViewItems.name, {
            inDayCount: JSON.stringify(dayViewItems?.map(items => items?.inDayItems?.length)),
            allDayCount: JSON.stringify(dayViewItems?.map(items => items?.allDayItems?.length)),
            dayToLoad: getDateString(dayToLoad),
        });

        /*
         * So that only the latest DayView Load request is served
         * when loadDayViewItemsOrchestrator is triggered for multiple actions
         */
        if (requestToken && requestToken < lastActiveRequestToken) {
            return;
        }

        const inDayItemsToSave = {};
        const allDayItemsToSave = {};

        daysToFetchData.forEach((day: OwaDate, index: number) => {
            const { inDayItems, allDayItems } = dayViewItems[index];
            const dayString: string = getDateString(day);
            inDayItemsToSave[dayString] = inDayItems;
            allDayItemsToSave[dayString] = allDayItems;
        });

        saveDayViewState(inDayItemsToSave, allDayItemsToSave, true /** clearAll to true */);

        // Do not show spinner as we have the day view items now
        onDayViewLoadingStatusChanged(false);
    } catch (error) {
        if (error !== 'REJECT_AS_STALE') {
            trace.errorThatWillCauseAlert(`[loadDayViewItems]: ${error}`);
        }
    }
}
